import ElementConstants from '../../elements';

const PublicSiteInputElements = {
	CONTACT:{
		type: ElementConstants.INPUTS.CONTACT,
		tag: 'contact',
		hint : '',
		label: '',
		required: true,
		attributes: {
			type: 'text',
			placeholder: ''
		}
	},
	ADDRESS: {
		type: ElementConstants.INPUTS.ADDRESS,
		tag: 'address',
		addressTitle: '<strong>Address</strong>',
		labelStreet: 'Street Address',
		labelCity: 'City',
		labelState: 'State',
		labelZip: 'Zip Code',
		hintStreet: '',
		hintCity: '',
		hintState: '',
		hintZip: '',
		required: true,
		hint: '',
		attributes: {
			placeholder: 'Please Select',
		},
		options: []
	},
	TEXT: {
		type: ElementConstants.INPUTS.TEXT,
		tag: 'input',
		label: 'Question',
		hint: '',
		required: false,
		attributes: {
			type: 'text',
			placeholder: ''
		}
	},
	TEXTAREA: {
		type: ElementConstants.INPUTS.TEXTAREA,
		tag: 'textarea',
		label: 'Question',
		hint: '',
		required: false,
		attributes: {
			placeholder: ''
		}
	},
	NUMBER: {
		type: ElementConstants.INPUTS.NUMBER,
		tag: 'input',
		label: 'Question',
		hint: '',
		required: false,
		attributes: {
			type: 'number',
			placeholder: ''
		}
	},
	LINK: {
		type: ElementConstants.INPUTS.LINK,
		tag: 'input',
		label: 'Question',
		hint: '',
		required: false,
		attributes: {
			type: 'url',
			placeholder: ''
		}
	},
	DATE: {
		type: ElementConstants.INPUTS.DATE,
		tag: 'input',
		label: 'Question',
		hint: '',
		required: false,
		attributes: {
			type: 'date',
			placeholder: ''
		}
	},
	TIME: {
		type: ElementConstants.INPUTS.TIME,
		tag: 'input',
		label: 'Question',
		hint: '',
		required: false,
		attributes: {
			type: 'time',
			placeholder: ''
		}
	},
	FILE_UPLOAD: {
		type: ElementConstants.INPUTS.FILE_UPLOAD,
		label: 'Question',
		hint: '',
		required: false
	},
	EMAIL: {
		type: ElementConstants.INPUTS.EMAIL,
		tag: 'input',
		label: 'Email',
		hint: '',
		required: false,
		attributes: {
			type: 'text',
			placeholder: ''
		}
	},
	RADIO_BUTTON: {
		type: ElementConstants.INPUTS.RADIO_BUTTON,
		tag: 'input',
		label: 'Option',
		required: false,
		attributes: {
			type: 'radio',
			value: ''
		}
	},
	MULTI_CHOICE_PAY_OPTION: {
		type: ElementConstants.INPUTS.MULTI_CHOICE_PAY_OPTION,
		tag: 'input',
        cost: '0.00',
        placeholder: 'Option',
		label: 'Option',
		required: false,
		attributes: {
			type: 'radio',
			value: ''
		}
	},
	OTHER_MULTI_CHOICE_PAY_OPTION: {
		type: ElementConstants.INPUTS.OTHER_MULTI_CHOICE_PAY_OPTION,
		tag: 'input',
        cost: '0.00',
		label: '0.00',
		required: false,
		attributes: {
			type: 'radio',
			value: ''
		}
	},
	CHECKBOX: {
		type: ElementConstants.INPUTS.CHECKBOX,
		tag: 'input',
		label: 'Option',
		required: false,
		attributes: {
			type: 'checkbox',
			value: ''
		}
	},
	PHONE: {
		type: ElementConstants.INPUTS.PHONE,
		tag: 'input',
		label: 'Phone',
		hint: '',
		required: false,
		attributes: {
			type: 'number',
			placeholder: 'Phone'
		}
	},
	USER_SIGNATURE: {
		type: ElementConstants.INPUTS.USER_SIGNATURE,
		label: 'Signature',
		defaultValue: 'Signature',
		appearOnce: true,
		disableRequired: true,
		hint: '',
		required: true
	},
}

export default PublicSiteInputElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/elements/public-site/inputs.js